var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as BVConstants from '../config/BVConstants';
import { fetchDataGetReq, fetchDataPostReq, fetchDataPutReq } from '../apis/apiUtil';
import { dateRangeObj } from './certificateService';
import { convertDataToSelectOptions, convertDataToSelectOptionsBVlocations } from '../utils/commonUtil';
import { prjStatusOptions } from '../models/StatusOptions';
// export async function getSearchSuggestions(searchStr: any, url: string) {
//   let jsonData = [];
//   try {
//     const response = await fetch(BVConstants.SERVICE_BASE_URI + url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: searchStr || ''
//     });
//     if (!response.ok) {
//       throw new Error('Network response was not ok.');
//     }
//     jsonData = await response?.json();
//   } catch (error) {
//     
//   }
//   return jsonData;
// }
export function getListProjectStatus() {
    const url = `getListProjectStatus`;
    return fetchDataGetReq(url);
}
export function getSearchSuggestions(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `getProjectSearchSuggestions`;
        return fetchDataPostReq(url, data);
    });
}
export function getPrjFilterSectionData(applicationData, selPrjStatus, setSelPrjStatus, selBrandList, setSelBrandList, selLstBVLocation, setSelLstBVLocation, selProjectType, setSelProjectType, selRecommendedStartDate, setSelRecommendedStartDate, selPlanedCompletionDate, setSelPlanedCompletionDate, selActualCompletionDate, setSelActualCompletionDate, handleClearAllAppliedFilters) {
    return {
        name: 'prj_filter_panel',
        selectOptionsList: selectOptionsList(selPrjStatus, setSelPrjStatus),
        multiSelectList: [
            multiSelectObj('Brand/OEM', selBrandList, setSelBrandList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.brandNamesWithIAProjects),
            multiSelectObjBVlocations('BV Location', selLstBVLocation, setSelLstBVLocation, applicationData === null || applicationData === void 0 ? void 0 : applicationData.bvCertLocations),
            multiSelectObj('Project Type', selProjectType, setSelProjectType, BVConstants.projectType)
        ],
        dateRangeOptions: [
            dateRangeObj('Recommended Start Date', selRecommendedStartDate, setSelRecommendedStartDate),
            dateRangeObj('Planned Completion Date', selPlanedCompletionDate, setSelPlanedCompletionDate),
            dateRangeObj('Actual Completion Date', selActualCompletionDate, setSelActualCompletionDate)
        ],
        handleClearAll: handleClearAllAppliedFilters
    };
}
export function selectOptionsList(selPrjStatus, setSelCertStatus) {
    return [
        {
            selectOptions: {
                data: prjStatusOptions,
                title: 'Filter By Project Status',
                value: selPrjStatus,
                setValue: (val) => setSelCertStatus(val)
            }
        }
    ];
}
export function multiSelectObj(title, selList, setSelList, jsonData) {
    return {
        multiSelect: {
            data: convertDataToSelectOptions(jsonData),
            title: title,
            value: selList,
            setValue: setSelList
        }
    };
}
export function multiSelectObjBVlocations(title, selList, setSelList, jsonData) {
    return {
        multiSelect: {
            data: convertDataToSelectOptionsBVlocations(jsonData),
            title: title,
            value: selList,
            setValue: setSelList
        }
    };
}
export function searchProjects(data) {
    const url = `searchClientArtifactsReact`;
    return fetchDataPutReq(url, data);
}
export function searchProjectsCount(data) {
    const url = `searchClientArtifactsReactCount`;
    return fetchDataPutReq(url, data);
}
export function getProjectDetails(data) {
    const url = `getProjectDetails`;
    return fetchDataPutReq(url, data);
}
export function getLstRiskReason(data) {
    const url = `getLstRiskReason`;
    return fetchDataPutReq(url, data);
}
export function getWoCertificates(data) {
    const url = `getArtifactVendorCertificates`;
    return fetchDataPutReq(url, data);
}
export function getCertificateDocument(data) {
    const url = `getDocument`;
    return fetchDataPutReq(url, data);
}
export function getBomDetails(data) {
    const url = `searchApprovalsBOMLazyLoad`;
    return fetchDataPutReq(url, data);
}
export function getBomFilterSectionData(applicationData, selCountryTerritoryList, setSelCountryTerritoryList, selServiceTypeList, setSelServiceTypeList, selProductTypeList, setSelProductTypeList, selTechnologyTypeList, setSelTechnologyTypeList, handleClearBOMAllAppliedFilters) {
    return {
        name: 'bom_filter_panel',
        multiSelectList: [
            multiSelectObj('Country/ Territory', selCountryTerritoryList, setSelCountryTerritoryList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.countryTerritoryList),
            multiSelectObj('Service Type', selServiceTypeList, setSelServiceTypeList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.serviceTypeList),
            multiSelectObj('Product Segment/ Sub Segment', selProductTypeList, setSelProductTypeList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.productTypeList),
            multiSelectObj('Technology Type', selTechnologyTypeList, setSelTechnologyTypeList, applicationData === null || applicationData === void 0 ? void 0 : applicationData.technologyTypeList)
        ],
        handleClearAll: handleClearBOMAllAppliedFilters
    };
}
export function getServiceSampleInfo(data) {
    const url = `getServiceSampleInfo`;
    return fetchDataPutReq(url, data);
}
export function getBOMServiceDocTypes(data) {
    const url = `getBOMServiceDocTypes`;
    return fetchDataPutReq(url, data);
}
export function getApprovalsBOMCount(data) {
    const url = `searchApprovalsBOMCount`;
    return fetchDataPutReq(url, data);
}
export function getBOMSearchSuggestions(bomSearchStr) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = `getBOMSearchSuggestions`;
        return fetchDataPutReq(url, bomSearchStr);
    });
}
export function getPrjEEMasterProducts(data) {
    const url = `getPrjEEMasterProducts`;
    return fetchDataPutReq(url, data);
}
export function getLstProductFamilyForProject(data) {
    const url = `getLstProductFamilyForProject`;
    return fetchDataPutReq(url, data);
}
